"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItem = _interopRequireDefault(require("../SectionListItem/ListItem"));

var _listHelpers = _interopRequireDefault(require("../../helpers/listHelpers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SectionList = function SectionListComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData;
  var items = sliceData.items,
      sectionListStyle = sliceData.primary.section_list_style;
  var listItemTypeMap = {
    Numbered: 'ol',
    Bulleted: 'ul'
  };
  var ListType = listItemTypeMap[sectionListStyle];

  var _columnizeListItems = (0, _listHelpers["default"])(items),
      leftColumnItems = _columnizeListItems.leftColumnItems,
      rightColumnItems = _columnizeListItems.rightColumnItems;

  return items.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__list-wrapper"
  }, leftColumnItems && /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__list-column-left"
  }, /*#__PURE__*/_react["default"].createElement(ListType, {
    className: "content-page__list"
  }, leftColumnItems.map(function (listItem, idx) {
    var counter = "".concat(idx + 1);
    var key = "".concat(listItem.list_item_type, "_").concat(idx);
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      listStyle: sectionListStyle,
      listItem: listItem,
      dataClient: dataClient,
      key: key,
      counter: counter
    });
  }))), rightColumnItems && /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__list-column-right"
  }, /*#__PURE__*/_react["default"].createElement(ListType, {
    className: "content-page__list"
  }, rightColumnItems.map(function (listItem, idx) {
    var counter = "".concat(leftColumnItems.length + idx + 1);
    var key = "".concat(listItem.list_item_type, "_").concat(idx);
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      listStyle: sectionListStyle,
      listItem: listItem,
      dataClient: dataClient,
      key: key,
      counter: counter
    });
  })))));
};
/* eslint-disable camelcase */


SectionList.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    primary: _propTypes["default"].shape({
      section_list_style: _propTypes["default"].string.isRequired
    }).isRequired
  }).isRequired
};
var _default = SectionList;
exports["default"] = _default;